<ng-container *ngIf="isAuthenticated(); else unauthenticated">

  <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#employee' }"
    [visible]="(loadingService.loading$ | async) || false"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
  >
  </dx-load-panel>

  <app-side-nav-inner-toolbar>
    <router-outlet></router-outlet>
    <app-footer> </app-footer>
  </app-side-nav-inner-toolbar>
</ng-container>

<ng-template #unauthenticated>
  <app-unauthenticated-content></app-unauthenticated-content>
</ng-template>
